<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="customCompanyName"
    item-value="companyCd"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import { CompanyCatCd } from '@/enum.js'

export default {
  name: 'PreparedCompanyInput',

  mixins: [APIUtils, Message],

  components: {
    SelectSingleInput,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0276')
      },
    },
  },

  data() {
    return {
      items: [],
      selectedItem: {},
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.company = value
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label
      },
    },
  },

  async mounted() {
    this.loading = true
    try {
      this.items = []

      const userCompany = await API.get(`/master/companies/${this.$store.getters.companyCd}`)
      userCompany['customCompanyName'] = userCompany['companyCd'] + ' : ' + userCompany['companyName']
      this.items.push(userCompany)

      const elements = await API.get('/master/companies', {companyCatCd: CompanyCatCd.EPSON})
      elements.forEach((element) => {
        element['customCompanyName'] = element['companyCd'] + ' : ' + element['companyName']
        this.items.push(element)
      })
    } catch (error) {
      this.items = []
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0005') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
